import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";

/**
 * Checks if a compliance case type is a recurring screening case
 * @param caseType - The compliance case type to check
 * @returns true if the case type is RecurringHit or Escalation, false otherwise
 */
export const isRecurringScreeningComplianceCase = (
  caseType: ComplianceCaseTypeEnum | string | undefined,
): boolean => {
  return (
    caseType === ComplianceCaseTypeEnum.RecurringHit ||
    caseType === ComplianceCaseTypeEnum.Escalation
  );
};
